import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Btn, H4, Image, P } from "../../AbstractElements";
import { SearchTableButton } from "../../utils/Constant";
import { URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import SweetAlert from 'sweetalert2';
import { useEffect, useMemo, useState } from "react";
import useRolesList, { changeStatus, deleteRole, submitData } from "./RoleApi";
import axios from "axios";
import { toast } from "react-toastify";

type Roles = { [key: string]: any }

const GestRoles = () => {

    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState<Roles[]>([]);
    const [refresh, setRefresh] = useState(false); // État de rafraîchissement
    const roles = useRolesList(refresh) || [];
    const [data, setData] = useState({
        libelle: '',
        id: null
    });
    const [erreur, setErreur] = useState({
        libelle: '',
        id: null
    });
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const filtered = roles.filter((item) =>
            item.libelle && item.libelle.toLowerCase().includes(filterText.toLowerCase())
        );

        if (JSON.stringify(filtered) !== JSON.stringify(filteredItems)) {
            setFilteredItems(filtered);
        }
    }, [roles, filterText, filteredItems]);


    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, type, value } = e.target;
        setData({ ...data, [name]: value, });
    };

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        // submitData({ data: data }, () => setRefresh(!refresh));
        const url = data.id !== null ? `${URL_API}/role/update/${data.id}` : `${URL_API}/role/create`

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {

            if (response.data.success) {
                const msg = data.id !== null ? "Rôle modifié avec succès !!" : "Rôle ajouté avec succès !!";
                toast.success(msg);
                clearDataForm();
            }

        }).catch(error => {
            // console.error(error.data);
            toast.info(error.response.data.message);
            if (error.status == 405) {
                setErreur(error.response.data.message);
            }
        })
        setRefresh((prev) => !prev);
    }

    const Confirmation = ({ id, type }: { id: number, type: string }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: type == 'supprimer' ? "De Vouloir Supprimer cet rôle ??" : "De vouloir changer le status de cet element",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: type == 'supprimer' ? 'Oui, Supprimer !' : 'Oui, Changer'
        }).then((result) => {
            if (result.isConfirmed) {
                type == 'supprimer' ? deleteRole({ id: id }, () => setRefresh(!refresh)) : changeStatus({ id: id }, () => setRefresh(!refresh)); // Passer une fonction de rappel pour mettre à jour l'état de rafraîchissement
            }
        });
    };

    const editerRole = ({ id }: { id: number }) => {
        const role = filteredItems.find((item) => item.id === id);
        if (role) {
            setData({
                libelle: role.libelle,
                id: role.id
            })
        } else {
            toast.info('Cet element de figure pas dans nos données')
        }

    }

    const clearDataForm = () => {
        setData({
            libelle: '',
            id: null
        });
        setErreur({
            libelle: '',
            id: null
        });
    }

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Roles" parent="Gestions" />
            <Container fluid>
                <Row>
                    <Col md="8">
                        <Card>
                            {/* <CardBody>{subHeaderComponentMemo}</CardBody> */}
                            <CardBody>
                                <Row>
                                    <Col sm="6">
                                        <div className="dataTables_filter d-flex align-items-center">
                                            <Label className="me-2">{SearchTableButton}:</Label>
                                            <Input
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                type="search"
                                                value={filterText}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                            <div className={`theme-scrollbar table table-striped bg-primary text-center`}>
                                <Table striped={true} hover={true} size={'sm'} responsive>
                                    <thead className={`tbl-strip-thad-bdr`}>
                                        <tr>
                                            <th scope="col">Id</th>
                                            <th scope="col">Libelle</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>{filteredItems.map((item, index) => (
                                        <tr key={item.id} className='text-center'>
                                            <th scope='row'>
                                                <span className="fw-bold text-dark">
                                                    #{index + 1}
                                                </span>
                                            </th>
                                            <td style={{ textAlign: "center" }}>
                                                <span className="fw-bold text-dark text-capitalize">
                                                    {item.libelle}
                                                </span>
                                            </td>
                                            <td>
                                                {item.status === 'actif' ? (
                                                    <Button className="btn btn-xs btn-success" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                        Activer
                                                    </Button>
                                                ) : (
                                                    <Button className="btn btn-xs btn-warning" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                        Desactiver
                                                    </Button>
                                                )}
                                            </td>
                                            <td>
                                                <Btn className='bg-info btn-xs mx-1 my-1' onClick={() => editerRole({ id: item.id })}>
                                                    <i className='fa fa-pencil'></i>
                                                </Btn>
                                                <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                                    <i className='fa fa-trash'></i>
                                                </Btn>
                                            </td>
                                        </tr>
                                    ))}</tbody>
                                </Table>
                            </div>

                            {/* </CommonTable> */}
                        </Card>
                    </Col>
                    <Col md="4">
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmitData}>
                                    <H4 className="my-4 text-capitalize">
                                        {
                                            data.id == null ? ("Ajouter un rôle") : ("Modification du rôle " + data.libelle)
                                        }
                                    </H4>

                                    <div className="product-info">
                                        <div className="product-group">
                                            <Row>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Libelle</Label>
                                                        <Input
                                                            placeholder="Entrer le nom ou le libelle"
                                                            name="libelle"
                                                            value={data.libelle}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.libelle && (
                                                            <span className="text-danger">{erreur.libelle}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <Btn color="info" type="submit">
                                            {data.id == null ? "Ajouter" : "Sauvegarder"}
                                        </Btn>
                                        <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>
                                            Annuler
                                        </Btn>
                                    </div>
                                </Form>
                            </CardBody>

                        </Card>

                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default GestRoles